import { TFunction } from 'i18next';

import { formatDateOfBirth } from '@components/Formik/DateOfBirth/utils';
import {
  CandidateDetailsFormValues,
  CandidateFormFieldsProps,
  CandidateFormInfoProps,
  CandidateFormValues,
} from '@presenters/web/pages/Leads/MMLPage/CandidateManagement/types';

import {
  getClubTypeOptions,
  getProfessionOptions,
} from '@domain/leads/referral/optionsList';

export const getCandidateFormInformation = (
  t: TFunction,
  formName: string
): CandidateFormFieldsProps => {
  const candidateFormField: CandidateFormInfoProps = {
    contactInformation: {
      clubType: {
        name: 'club_type',
        label: t('join-form-referral.field_club_type_label', 'Club type'),
        options: getClubTypeOptions(t),
        required: true,
      },
      firstName: {
        name: 'firstName',
        label: t('mml.add-new-candidate.first-name-label', 'First name'),
        required: true,
      },
      lastName: {
        name: 'lastName',
        label: t('mml.add-new-candidate.last-name-label', 'Last name'),
        required: true,
      },
      email: {
        name: 'email',
        label: t('mml.add-new-candidate.email-label', 'Email'),
        required: true,
      },
      phoneCode: {
        name: 'phone_code',
        label: t('mml.add-new-candidate_phone_code_label', 'Country code'),
        required: false,
      },
      phoneNumber: {
        name: 'phone_number',
        label: t('mml.add-new-candidate_phone_number_label', 'Phone'),
        required: false,
      },
      gender: {
        name: 'gender',
        label: t('mml.add-new-candidate.gender-label', 'Gender'),
        required: false,
      },
      genderDescription: {
        name: 'genderDescription',
        label: '',
        required: false,
      },
    },
    candidateAddressDetails: {
      addressTypeSelect: {
        name: 'type',
        label: t(
          'mml.add-new-candidate.address_type_select_label',
          "Candidate's address type"
        ),
        required: true,
      },
      addressFields: {
        name: 'mml.add-new-candidate_address_fields',
        formAddress: {
          placeholder: {
            lineTwo: t(
              'mml.add-new-candidate.address_fields_line_two_placeholder',
              'Second line optional'
            ),
            lineThree: t(
              'mml.add-new-candidate.address_fields_line_three_placeholder',
              'Third line optional'
            ),
          },
          name: {
            lineTwo: 'primaryAddress.lineTwo',
            lineOne: 'primaryAddress.lineOne',
            lineThree: 'primaryAddress.lineThree',
            countryId: 'primaryAddress.countryId',
            city: 'primaryAddress.city',
            stateId: 'primaryAddress.stateId',
            state: 'primaryAddress.state',
            internationalProvince: 'primaryAddress.state',
            hasStates: 'primaryAddress.hasStates',
            postalCode: 'primaryAddress.postalCode',
          },
        },
      },
      interest: {
        name: 'clubMeetingPreferenceInterest',
        label: t(
          'mml.add-new-candidate.interest_label',
          'They are interested in an online meeting option, if possible.'
        ),
      },
      additionalComments: {
        name: 'additional_comments',
        label: t(
          'mml.add-new-candidate.field_additional_comments_label',
          'Additional comments'
        ),
        required: false,
      },
      profession: {
        name: 'profession',
        label: t(
          'join-form-referral.field_profession_label',
          'What is their profession?'
        ),
        required: false,
        options: getProfessionOptions(t),
      },
    },
  };
  return candidateFormField[formName];
};

export const getCandidateFormInitialValue = (formName: string = '') => {
  const formInitialValue: CandidateFormValues = {
    contactInformation: {
      club_type: 'rotary',
      firstName: '',
      lastName: '',
      email: '',
      phone_number: '',
      genderDescription: '',
    },
    candidateAddressDetails: {
      type: '',
      interestGroupId: '',
      primaryAddress: {
        lineTwo: '',
        lineOne: '',
        lineThree: '',
        countryId: '',
        city: '',
        stateId: '',
        state: '',
        internationalProvince: '',
        hasStates: '',
        postalCode: '',
      },
    },
  };
  return formInitialValue[formName] || {};
};
export const confirmCandidateInitialValues: CandidateDetailsFormValues = {
  ...formatDateOfBirth('', ''),
  email: '',
  yearOfBirth: '',
  firstName: '',
  lastName: '',
  middleName: '',
  localizedName: '',
  gender: '',
  suffix: '',
  prefix: '',
  birthdate: '',
  primaryPhone: { countryId: '', number: '' },
  primaryAddress: {
    lineTwo: '',
    lineOne: '',
    lineThree: '',
    countryId: '',
    city: '',
    stateId: '',
    state: '',
    internationalProvince: '',
    hasStates: false,
    postalCode: '',
  },
  primaryLanguage: '',
};
